import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import {
  CalendarHolidaysRequestModel,
  CalendarModel,
  HolidayType,
} from "../model/domain/CalendarModel";

@Injectable({
  providedIn: "root",
})
export class CalendarService {
  constructor(private http: HttpClient) {}

  private readonly name = "calendar";

  getHolidaysTypeList(): Observable<HolidayType[]> {
    return this.http.get<HolidayType[]>(
      `${environment.apiUrls.tickets}/${this.name}/get-holidays-types`
    );
  }

  getHolidaysList(): Observable<CalendarModel[]> {
    return this.http.get<CalendarModel[]>(
      `${environment.apiUrls.tickets}/${this.name}/get-holidays`
    );
  }

  getNextHolidaysList(): Observable<CalendarModel[]> {
    return this.http.get<CalendarModel[]>(
      `${environment.apiUrls.tickets}/${this.name}/get-next-holidays`
    );
  }

  deleteHoliday(id: number): Observable<any> {
    return this.http.delete(
      `${environment.apiUrls.tickets}/${this.name}/delete-holiday/${id}`
    );
  }

  updateHolidays(model: CalendarHolidaysRequestModel): Observable<any> {
    return this.http.post<CalendarHolidaysRequestModel[]>(
      `${environment.apiUrls.tickets}/${this.name}/update-holidays`,
      model
    );
  }

  registerHoliday(model: CalendarModel): Observable<any> {
    return this.http.post<CalendarModel>(
      `${environment.apiUrls.tickets}/${this.name}`,
      model
    );
  }
}
